export default __webpack_public_path__ + "static/media/greenscreens-icon.2a8174f7.png";